import { useQuery } from '@tanstack/react-query'

import { FetchOrgFeatureFlags } from '@/services/FeatureFlagService'

export const useOrgFeatureFlags = (orgId: string) => {
  return useQuery({
    queryKey: ['org-feature-flags', orgId],
    queryFn: () => FetchOrgFeatureFlags(orgId),
    enabled: Boolean(orgId),
  })
}
